import React from 'react'
import companyLogo from './logo1.png'
import "./Topbar.css"
import {Link} from "react-router-dom"
export default function Topbar() {
  return (
    <div className='topbar'>
        <div className="topbarMenu">
            <h1 className="logo"> <img className='logoImg' src={companyLogo} alt="CBR"/></h1>
           
        <div className="topbarRight">
            <ul className="topbarRightlist">
                <li className="topbarItem">
                  <Link className='topbarItemLink' exact to={"/"} style={{textDecoration: "none"}}>Home</Link>
                  </li>
                <li className="topbarItem">Contact
                  {/* <Link className='topbarItemLink' exact to={"contact"} style={{textDecoration: "none"}}>Contact</Link> */}
                  </li>
                <li className="topbarItem">About
                  {/* <Link className='topbarItemLink' exact to={"about"} style={{textDecoration: "none"}}>About</Link> */}
                  </li>
                <li className="topbarItem">Journal
                  {/* <Link className='topbarItemLink' exact to={"journal"} style={{textDecoration: "none"}}>Journal</Link> */}
                  </li>
            </ul>
        </div>
        </div>
    </div>
  )
}
